<template>
  <RetryableWrapper
    v-if="videoDuration >= minVideoDuration"
    ref="retryableWrapper"
    class="video-slice-retryable-wrapper"
    :refreshFn="refreshFn"
    :status="getOutLineStatus"
    :height="160"
  >
    <!-- loading -->
    <template #loading>
      <div class="custom-loading">
        <div class="scroll-cont">
          <div class="video-node-list-wrap">
            <div v-for="item in 8" :key="item" class="loading-video-node">
              <div class="cont-wrap"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="outLineList?.length" class="video-slice-list-component">
      <div ref="scrollCont" class="scroll-cont">
        <div ref="nodeList" class="video-node-list-wrap">
          <div
            @click="handleNodeClick(index, item)"
            class="video-node"
            :class="{
              'is-expand': isExpandIndex === index,
              ['video-node-' + index]: true,
            }"
            v-for="(item, index) in outLineList"
            :key="index"
          >
            <div class="duration">
              {{ formatTimeBySeconds(item.start_second) }}
            </div>
            <div class="video-node-cont">
              <div class="node-img-wrap">
                <img
                  class="node-img"
                  :src="getSliceImageUrl(item)"
                  alt=""
                  :onerror="errorImg"
                />
              </div>
              <p class="node-title ellipsis">{{ item.title }}</p>
              <div class="cont-detail">
                <div>
                  <p class="expand-title ellipsis">{{ item.title }}</p>
                  <p class="intro">{{ item.content }}</p>
                </div>
                <div class="operate-wrap">
                  <!-- 收起 -->
                  <button @click.stop="handleRetract" class="retract-btn">
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 切换 -->
      <button
        v-show="showLeftBtn"
        @click="handleScroll('left')"
        class="left-btn"
      >
        <i class="el-icon-arrow-left"></i>
      </button>
      <button
        v-show="showRightBtn"
        @click="handleScroll('right')"
        class="right-btn"
      >
        <i class="el-icon-arrow-right"></i>
      </button>
    </div>
    <div v-else class="empty-cont">
      <img src="../../../assets/images/icon/list-empty.png" alt="" />
      <p class="tips">该视频没有独立字幕，无法总结</p>
    </div>
  </RetryableWrapper>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { handleImageUrl } from "@saas/components";
// import { getLessonOutline } from "@saas/service-api/src/learning-center";
import {
  isH5,
  isMobile,
  RetryableWrapper,
  formatTimeBySeconds,
} from "@saas/components/src";
export default {
  props: {
    courseId: {
      type: String,
      default: "",
    },
    lessonId: {
      type: Number,
      default: null,
    },
    videoDuration: {
      type: Number,
      default: 0,
    },
    courseCoverUrl: {
      type: String,
      default: "",
    },
  },
  components: {
    RetryableWrapper,
  },
  data() {
    return {
      formatTimeBySeconds,
      status: "loading",
      isExpandIndex: -1,
      showLeftBtn: false,
      showRightBtn: false,
      videoList: [],
      expandWidth: 400,
      isH5: isH5(),
      isMobile: isMobile(),
      handleImageUrl,
      minVideoDuration: 15 * 60, //视频时长在15分钟以上，否则不生成
      errorImg:
        "this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyCAYAAAAA9rgCAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAADygAwAEAAAAAQAAADIAAAAA5mLvnAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAB/1JREFUaAXdmmlwFEUUx7dnl+CtIRzeeB9I4RUvRCTZDQkRS/FALDzAKqtUsMQPFn5QC8/y+OJV5W1ZGpWKWt4h2d0kiolawgctFf2g8AFvDIUWFMkmu+PvTXbW3t5dmZnsBnAqk+l+/fp1//t1v37vJSpkPG1tbfuNHTv2OttWF4VC9ok0T+C1DLYRVtVdsVj9vaaQZDJ5RSikXoUeNts81jPwbULGd0rZ7w4MDLzY3Nz8t95X6RUGXAjzo9DG6/Tylu3HY7HYLabMRKLrIib5JvSI2TaC+p8obRnjySI6T05zyWTXnYBtgVpBsKGWaDS6LDt27gPYRsC2QignWJEPFtUyjG14OEfDaHYBDa8Pk5zfsjIPUvo0lUp9m06nh7S2wMW5c+duVyAzBXR3d++xdevW3OKb7V7r4XA4UlVVdRL808FzO19NefaVaHqlYrB90unMjzROzAruBqw0/p6t75YflDgpq8S6LIA/wmHraCuTySyC4IBVKrQplRpzxe4OVgAKBsEimKTOM1GwWsPWeJhi2/bdzc0zXYZh4m78W7AIJheCYOXc2FNcAt9PtPL/pahhsqeIoWCvO0+aQ78uW/7ffLKY0llAkwSwe8ln6urqymKNd6XVymISh0Se8IivgmE5u8/vEV30ra2tVdXV45dwtc4D8tG8g7zrMA4tDQ31r+2KyxAYcFdX1+lYwJd4pxrAJrMAc/Burg6H1fVsqZ+M9p1aDbSlOzs7J2cydpdth0ywGhi7CYcmLl6URtzpRd+A0aji5yVmvp+H2Z/IZf+AB75RY/ENGJftXO7uWV5nyC5YipYP8MpfaT7fgAmNZ/ic1BiCj7N99qkYu2/AGKRxAWZTE6BPRbr4BswsgkRRQfrsGoAty0r6nMl2tvRnPvtUjN23huvr679iNiu9zojw7P7GxsZtXvmL8cnVhrGcxveIYu1+aL4Bi/ChocElfH7Z8UD25319fZI5GdEza9asAYzlQ9zrG5LJzp8Tic4n8AUOCSI0EOCmpqbNZA/OYsBVpQZFs8+RHmqcP3++G6mUYi2gy12vEyUtlE4PXgvtN96Dkb2U6+4HQC/V+byUFSvm5pgGY7FolZdOOg9b7WLq85iU+NISba3D2XitoaGhR+fzWu7o6D4hHM48SxptjnkUGKuBtE0HsnILAvCne3s/WbJixQo3IioYCowpiGOkYcSAC6SPgBCPx4/FKH7MtA5Ci3eQ4bzfFMfk5Ygsz6fbL/f09CwuBVoHHGhL5w9WnhraO8qywl0CFk/uS3bJk8UksxBFghF1zYwZM18menNj+2JdHdouAViCEYCSLQ0dyvsjbxNH4i9nhtov+BaxhR/XSFrRXjhuXE3LjkDvdMAdHR2HYaME7OFo9lfObkOxrCk7YAFgX4Avd341tG5xAaBf5/qKuATzW7LBZCxWl9Wsqam5hAlfQDtGy06x5b6lvJLz92mxPjpNrhZAANY+EvoWrDN2qnGDziNl+ObB9wpFLwq6HEfHWrt27ZW1tbWSkMh7vAjI6+BW4vHuUwD7DRPhTyT2tbwSVNRTv5m3F428iSHZ1+U3v2jhQPg4s06mZHsmo+ayjb82+Ug0NMMnjo4P5ahLt2z5qxXQjmXWZQYCDJiYZWV6mcgJurD8srq0v3/gI4AVhIZs44k4EQL2ON4hy1KXzZ5d35vfPxSKx7uiJBregu77uqTPxYB+S9JQulzfgAFbxzF6DyF76YJKlE+TrEcikdjfbWcBxkcikU7q8qdYm5/FuKttbrv7ZZzzLMuWcfZwaQG+F1ZX17xNv9y597FNnBU/nwl+gIA9fQx+hlLWKrZ3I38wIzbOSPCRTQ3Zt2KgWkxZbOOz0OyH0L0sqtk9r45NadYJngFjOGZiVIJO4pz+/lRbJDJGFupkmQATuS8ajT2mT0bK7IZTAdtOseT5N/v4qXsCzCRmcF4F7N5+hOfzOkYtS1LPRKP1d+a3h0K4lVOVyiSgF5x7kzdofYeA0ex0wMoZ2yfoIEa/N3p6Vt9k0EJs4+PxrmS7VzQ78p9GK5HoPhuwEhGVaXup5ObNfVeZPi8G6ii2sRiySeZClLteEjCaPZPtJWfJSzrWy7zWkJifR7gokUvu4bjgYSm5ogLFtzlBHgtFAeNU1KLZODJy14lHeUXZMFDfEz8381eIrTpDe/tqAgVLNDtZp1eyXAAYzZ6GUyGGoyxg0d7GoaGh2YD9UwfS1rZ6QiQy2MliHKPTK10Wo8Xl71zMSq4ENCuGo1xWsi+dVrPxjzfqQNrb28cBVsYR52M0H1s03JcdMYKD0E25ukwzYPvaZC3qvtflsaj742lJ1mKaTh+lcp8AXq8NVqZt7DgWN+FFrdFkO0UWtYXWWpM+SvX1FmeowI8tx+AcjRuKx6X2C+WQH0SGYLUwKC/SuT+IgB30mY4jca/Jg9bfgfa8SR+Fer9gtYYNinq4EgOi5eU4FQ2mbLIay2j7waRXtq4eFqzOtYSrdzeDSRRU7oewTL0C6DwPioG3WVZoIYMNlXvAEvLez2L8N06U80ZqhOhF3UinXPxYQoAvMtqM8+/CTeb/WSadf2i17/ElzB8zV679FP+6dAt+gLO4BcDEpWSCtyF3Du8IoiNzZvZyzm/e0ZGcGEm31XDyz6BlfbYhbRVG6hFya1/okgsAu42SGiFndVgmY00gDg679KBfvLdUsWtKMiCDg/bxQeXq/dhBacbZxN+zNpo+u8v3DzttAOVqcIvIAAAAAElFTkSuQmCC';this.style.width='60px';this.style.height='50px';",
    };
  },
  mounted() {
    window.removeEventListener("resize", this.handleWinResize, true);
    window.addEventListener("resize", this.handleWinResize, true);
  },
  watch: {
    // lessonId: {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.setSubTitle("");
    //       this.initData();
    //     }
    //   },
    //   immediate: true,
    // },
    outLineList: {
      handler(newVal) {
        if (newVal?.length) {
          this.$nextTick(() => {
            this.handleScrollBtn(200);
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    // ...mapMutations("replay", ["setSubTitle"]),
    ...mapActions("replay", ["apiGetLessonOutline"]),
    refreshFn() {
      this.apiGetLessonOutline({
        lesson_id: this.lessonId,
      });
    },
    getSliceImageUrl(item) {
      const imageUrl = item.img_path || this.courseCoverUrl;
      return this.handleImageUrl(imageUrl) + "?imageView2/0/w/320";
    },
    // initData() {
    //   this.status = "loading";
    //   getLessonOutline({ lesson_id: this.lessonId })
    //     .then((res) => {
    //       if (res.code === 1) {
    //         this.videoList = res.data?.outline || [];
    //         this.setSubTitle(res.data?.subtitle || "");
    //         this.status = "success";
    //         this.$nextTick(() => {
    //           this.handleScrollBtn(200);
    //         });
    //         window.addEventListener("resize", this.handleWinResize, true);
    //       } else {
    //         this.status = "error";
    //       }
    //     })
    //     .catch(() => {
    //       this.status = "error";
    //     });
    // },
    handleWinResize() {
      this.handleScrollBtn(1500);
    },
    handleScroll(direction) {
      const changeValue = this.$refs.scrollCont.clientWidth * 0.7;
      if (direction === "left") {
        this.$refs.scrollCont.scrollLeft -= changeValue;
      } else {
        this.$refs.scrollCont.scrollLeft += changeValue;
      }
      this.handleScrollBtn(500);
    },
    handleScrollBtn(timeout = 0) {
      setTimeout(() => {
        if (this.isH5 || !this.$refs?.scrollCont) {
          return;
        }
        const scrollClientWidth = this.$refs.scrollCont.clientWidth;
        const nodeListWidth = this.$refs.nodeList.clientWidth;
        if (scrollClientWidth >= nodeListWidth) {
          this.showLeftBtn = false;
          this.showRightBtn = false;
        } else {
          const scrollLeft = this.$refs.scrollCont.scrollLeft;
          const scrollWidth = this.$refs.scrollCont.scrollWidth;
          console.log(
            "scrollLeft",
            scrollLeft,
            scrollWidth,
            scrollClientWidth,
            scrollLeft === 0,
            scrollLeft + scrollClientWidth === scrollWidth
          );

          if (scrollLeft === 0) {
            this.showLeftBtn = false;
            this.showRightBtn = true;
          } else if (scrollLeft + scrollClientWidth + 15 >= scrollWidth) {
            this.showLeftBtn = true;
            this.showRightBtn = false;
          } else {
            this.showLeftBtn = true;
            this.showRightBtn = true;
          }
        }
      }, timeout);
    },
    handleNodeClick(index, item) {
      this.isExpandIndex = index;
      //播放当前节点
      this.$emit("playCurNode", item.start_second);
      setTimeout(() => {
        //   判断元素是否在可视区域
        const currentEl = document.querySelector(
          `.video-slice-list-component .video-node-${index}`
        );
        const { offsetLeft } = currentEl;
        const { scrollLeft, clientWidth } = this.$refs.scrollCont;
        console.log("offsetTop", offsetLeft, scrollLeft, clientWidth);
        const containerLeft = scrollLeft;
        const containerRight = scrollLeft + clientWidth;
        const itemLeft = offsetLeft;
        const itemRight = offsetLeft + this.expandWidth;
        if (itemLeft < containerLeft) {
          this.$refs.scrollCont.scrollLeft = itemLeft - 10;
        } else if (itemRight > containerRight) {
          this.$refs.scrollCont.scrollLeft = itemRight - clientWidth + 10;
        }
      }, 300);
      this.handleScrollBtn(600);
    },
    handleRetract() {
      this.isExpandIndex = -1;
      this.handleScrollBtn(600);
    },
  },
  computed: {
    ...mapState("replay", ["outLineList", "getOutLineStatus"]),
  },
};
</script>

<style scoped lang="scss">
$expandWidth: 400px;
.video-slice-retryable-wrapper,
.video-slice-list-component {
  --video-slice-card-bg: rgba(255, 255, 255, 0.5);
  --video-slice-elevated-bg: var(--mg-bg-card, #ffffff);
  --video-slice-text: var(--mg-text-secondary, #4e5969);
  --video-slice-primary-text: var(--mg-text-primary, #0d1400);
  --video-slice-muted: var(--mg-text-muted, #86909c);
  --video-slice-line: #86909c;
  --video-slice-control-hover-bg: #e5e6eb;

  html.dark & {
    --video-slice-card-bg: rgba(var(--mg-bg-surface-rgb), 0.72);
    --video-slice-elevated-bg: var(--mg-bg-surface);
    --video-slice-text: var(--mg-text-secondary);
    --video-slice-primary-text: var(--mg-text-primary);
    --video-slice-muted: var(--mg-text-muted);
    --video-slice-line: #64748b;
    --video-slice-control-hover-bg: var(--mg-control-hover-bg);
  }
}

.empty-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90%;
  height: 160px;
  border-radius: 6px;
  background: var(--video-slice-card-bg);
  margin: 43px auto 0;
  img {
    width: 60px;
    height: 60px;
  }
  .tips {
    font-size: 12px;
    color: var(--video-slice-primary-text);
    line-height: 22px;
    margin-top: 2px;
  }
}
.video-slice-retryable-wrapper {
  margin-top: 25px;
}
.custom-loading {
  display: flex;
  // flex-wrap: nowrap;
  justify-content: center;
  // align-items: flex-start;
  // width: max-content;
  .loading-video-node {
    padding-top: 10px;
    padding-left: 8px;
    padding-right: 8px;
    position: relative;
    &::before {
      display: block;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 4px;
      background: var(--video-slice-line);
      border-radius: 50%;
    }
    &::after {
      display: block;
      content: "";
      position: absolute;
      height: 1px;
      top: 2px;
      left: 8px;
      width: 180px;
      border-top: 1px dashed var(--video-slice-line);
    }
    .cont-wrap {
      width: 180px;
      height: 102px;
      background: var(--video-slice-elevated-bg);
      border-radius: 6px;
      opacity: 0.5;
    }
  }
}
.video-slice-list-component {
  position: relative;
  // padding-top: 25px;
}
.scroll-cont {
  max-width: 100%;
  // width: 100%;
  width: max-content;
  overflow-x: scroll;
  overflow-y: hidden;
  margin: 0 auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: 0;
  /* 标准语法，Firefox 支持 */
  -ms-overflow-style: none;
  /* IE 和 Edge */
  &::-webkit-scrollbar {
    display: none;
    /* WebKit 内核浏览器 */
  }
}
.video-node-list-wrap {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  width: max-content;
}
.video-node {
  width: 200px;
  height: 170px;
  border-radius: 6px;
  padding: 4px 0 0 2px;
  transition: width 0.3s ease, height 0.3s ease;
  flex-shrink: 0;
  .cont-detail {
    display: none;
  }
  &:hover {
    cursor: pointer;
    background: var(--video-slice-card-bg);
    .node-img {
      transform: scale(1.2) rotate(0.02deg);
    }
    .node-img-wrap {
      background: transparent;
    }
  }
  &.is-expand {
    width: 400px;
    min-height: 192px;
    height: max-content;
    transition: width 0.3s ease, height 0.3s ease;
    background: var(--video-slice-elevated-bg);
    display: flex;
    flex-direction: column;
    .video-node-cont {
      display: flex;
      .node-title {
        display: none;
      }
      .cont-detail {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100%;
      }
    }
    .node-img {
      transform: none;
    }
  }

  .duration {
    font-weight: 400;
    font-size: 11px;
    color: var(--video-slice-text);
    line-height: 16px;
    margin-bottom: 6px;
  }
  .node-img-wrap {
    width: 180px;
    min-width: 180px;
    height: 102px;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--video-slice-card-bg);
  }
  .node-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.3s ease-in-out;
    will-change: transform;
    transform: scale(1) rotate(0.02deg);
  }
  .node-title {
    font-size: 12px;
    color: var(--video-slice-text);
    line-height: 17px;
  }
  .video-node-cont {
    flex: 1;
    padding: 10px 0 4px 0;
    margin-left: 10px;
    margin-right: 4px;
    border-top: 1px dashed var(--video-slice-line);
    position: relative;
    &::before {
      position: absolute;
      content: "";
      top: -3px;
      left: -8px;
      width: 4px;
      height: 4px;
      background: var(--video-slice-line);
      border-radius: 50%;
    }
  }
  .cont-detail {
    margin-left: 6px;
    .expand-title {
      font-weight: 500;
      font-size: 12px;
      color: var(--video-slice-text);
      line-height: 17px;
      margin-bottom: 3px;
    }
    .intro {
      font-size: 12px;
      color: var(--video-slice-text);
      line-height: 17px;
    }
    .operate-wrap {
      display: flex;
      justify-content: flex-end;
      padding-right: 14px;
      padding-bottom: 6px;
    }
    .retract-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: var(--video-slice-muted);
      line-height: 17px;
      padding: 4px 0;
      i {
        width: 8px;
        color: var(--video-slice-muted);
        margin-left: 6px;
      }
    }
  }
}
.left-btn,
.right-btn {
  position: absolute;
  width: 30px;
  height: 30px;
  background: var(--video-slice-elevated-bg);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 70px;
  i {
    font-size: 18px;
    color: var(--video-slice-text);
    font-weight: bold;
  }
  &:hover {
    cursor: pointer;
    background: var(--video-slice-control-hover-bg);
  }
}
.left-btn {
  left: 85px;
}
.right-btn {
  right: 85px;
}

.video-slice-retryable-wrapper,
.video-slice-list-component {
  html.dark & {
  .empty-cont {
    background: var(--video-slice-card-bg);

    .tips {
      color: var(--mg-text-primary);
    }
  }

  .custom-loading .loading-video-node {
    &::before {
      background: var(--video-slice-line);
    }

    &::after {
      border-top-color: var(--video-slice-line);
    }

    .cont-wrap {
      background: var(--video-slice-elevated-bg);
    }
  }

  .video-node {
    &:hover {
      background: var(--video-slice-card-bg);
    }

    &.is-expand {
      background: var(--video-slice-elevated-bg);
    }

    .duration,
    .node-title,
    .expand-title,
    .intro {
      color: var(--mg-text-secondary);
    }

    .node-img-wrap {
      background: var(--video-slice-card-bg);
    }

    .video-node-cont {
      border-top-color: var(--video-slice-line);

      &::before {
        background: var(--video-slice-line);
      }
    }

    .retract-btn,
    .retract-btn i {
      color: var(--mg-text-muted);
    }
  }

  .left-btn,
  .right-btn {
    background: var(--video-slice-elevated-bg);

    i {
      color: var(--mg-text-secondary);
    }

    &:hover {
      background: var(--mg-control-hover-bg);
    }
  }
  }
}
</style>
